import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Category', 'Categories'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
